// Counts the conversation-level updates (websocket events and the agent's own assign / status
// changes) each conversation has received in this tab. syncActiveConversationMessages notes the
// count before it asks the server and compares it afterwards: if anything newer arrived while
// the request was in flight, the response's assignee / status may already be stale and is not
// applied. A plain Map, not Vuex state: nothing renders from it.
const stamps = new Map();

export const touchConversation = id => {
  if (id === undefined || id === null) return;
  stamps.set(id, (stamps.get(id) || 0) + 1);
};

export const conversationStamp = id => stamps.get(id) || 0;
